var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "trip-sheet-pdf"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    attrs: {
      "id": "printPDFData"
    }
  }, [_c('div', {
    staticClass: "pagebreak"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "border": "1px solid black",
      "margin-bottom": "7px"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.tripdata.barcodevalue,
      "width": "1",
      "height": "25",
      "fontSize": "10"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Trip Type :FLM"), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-18px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickup),
      expression: "pickup"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Pickup",
      "value": "Pickup"
    },
    domProps: {
      "checked": Array.isArray(_vm.pickup) ? _vm._i(_vm.pickup, "Pickup") > -1 : (_vm.pickup)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.pickup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Pickup",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pickup = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.pickup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pickup = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Pickup"
    }
  }, [_vm._v("Pickup")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "Delivery",
      "value": "Delivery"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Delivery"
    }
  }, [_vm._v("Delivery")])])])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Number: " + _vm._s(_vm.tripdata.vehicleNumber))])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip ID: " + _vm._s(_vm.tripdata.tripid))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle type : " + _vm._s(_vm.tripdata.vehicleType))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Branch Name: " + _vm._s(_vm.tripdata.BranchName) + "(" + _vm._s(_vm.tripdata.BranchCode) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Name: " + _vm._s(_vm.tripdata.vehicleVendorName))])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Assigned to: " + _vm._s(_vm.tripdata.username) + " (" + _vm._s(_vm.tripdata.userid) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle make: " + _vm._s(_vm.tripdata.vehicleVendorType))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Destination:")]), _vm._v(" " + _vm._s(_vm.tripdata.destinationhubname))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("Vehicle Odo reading (km):")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("End")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.startkm))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.endkm))])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip start date: " + _vm._s(_vm.tripdata.tripstartdate))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Pickups")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total pickup location: " + _vm._s(_vm.tripdata.pickups.length > 0 ? _vm.tripdata.pickups.length : ""))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Total AWB to be picked:\n                      " + _vm._s(_vm.tripdata.totalAwbPick))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total Physical Wt:\n                      " + _vm._s(_vm.tripdata.FmTotalPhysicalWt))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total MPS to be picked:" + _vm._s(_vm.tripdata.totalMpsFm))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  })]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Client Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Address")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("AWB/"), _c('br'), _vm._v("Requested"), _c('br'), _vm._v(" Pickup")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("AWB/Requested Pickup ID ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Booked Physical Wt(Kg)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Actual Physical Wt(Kg)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("#MPS (Booked)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("#MPS (Actual)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Signature with Name/Stamp/"), _c('br'), _vm._v("ID/Remarks")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tripdata.pickups), function(client, index) {
    return (_vm.tripdata.pickups.length > 0) ? [_vm._l((client.shipments), function(shipment, ind) {
      return [(ind == 0) ? [_c('tr', {
        staticStyle: {
          "background-color": "white"
        }
      }, [_c('td', {
        staticClass: "text-center",
        attrs: {
          "rowspan": client.shipments.length,
          "scope": "rowgroup"
        }
      }, [_vm._v("\n                            " + _vm._s(client.clientname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "rowspan": client.shipments.length,
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.address))]), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s(shipment.pincode))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('span', [_vm._v(_vm._s(shipment.type))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "padding": "50px"
        },
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.awb))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.physcialWeight))])]), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.bookedMps))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(shipment.actualMps))]), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      })])] : (ind > 0) ? [_c('tr', {
        staticStyle: {
          "background-color": "white"
        }
      }, [_c('td', {
        staticClass: "text-center"
      }, [_c('span', [_vm._v(_vm._s(shipment.type))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "padding": "50px"
        },
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.awb))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.physcialWeight))]), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.bookedMps))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.actualMps))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      })])] : _vm._e()]
    })] : _vm._e()
  }), _vm._v(" "), (_vm.tripdata.totalAwbPick < 6 || !_vm.tripdata.totalAwbPick) ? _vm._l(((!_vm.tripdata.totalAwbPick ? 6 : (6 - _vm.tripdata.totalAwbPick))), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "style1"
    }), _vm._v(" "), _c('td', {
      staticClass: "style2"
    }), _vm._v(" "), _c('td', {
      staticClass: "style6"
    }), _vm._v(" "), _c('td', {
      staticClass: "style3"
    }), _vm._v(" "), _c('td', {
      staticClass: "style7",
      attrs: {
        "width": "20"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "style7",
      attrs: {
        "width": "20"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "style4"
    }), _vm._v(" "), _c('td', {
      staticClass: "style5"
    }), _vm._v(" "), _c('td', {
      staticClass: "style6"
    })])
  }) : _vm._e()], 2)])]], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "right",
      "border": "1px solid black",
      "margin-bottom": "7px"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.tripdata.barcodevalue,
      "width": "1",
      "height": "25",
      "fontSize": "10"
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "checkbox",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Trip Type :FLM "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-left": "120px",
      "margin-top": "-18px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "Pickup",
      "value": "Pickup"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Pickup"
    }
  }, [_vm._v("Pickup")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery),
      expression: "delivery"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Delivery",
      "value": "Delivery"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery) ? _vm._i(_vm.delivery, "Delivery") > -1 : (_vm.delivery)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.delivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Delivery",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Delivery"
    }
  }, [_vm._v("Delivery")])])])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Number:" + _vm._s(_vm.tripdata.vehicleNumber))])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip ID: " + _vm._s(_vm.tripdata.tripid))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle type : " + _vm._s(_vm.tripdata.vehicleType))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Branch Name: " + _vm._s(_vm.tripdata.BranchName) + "(" + _vm._s(_vm.tripdata.BranchCode) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Name:" + _vm._s(_vm.tripdata.vehicleVendorName))])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Assigned to: " + _vm._s(_vm.tripdata.username) + " (" + _vm._s(_vm.tripdata.userid) + ")")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle make:" + _vm._s(_vm.tripdata.vehicleVendorType))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip start date: " + _vm._s(_vm.tripdata.tripstartdate))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Odo reading (km):")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("End")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.startkm))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.endkm))])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "50%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Deliveries")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "width": "50"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total Delivery location:\n                      " + _vm._s(_vm.tripdata.deliveries.length > 0 ? _vm.tripdata.deliveries.length : ""))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Total AWB to be delivered:\n                      " + _vm._s(_vm.tripdata.totalAwbDeliver))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Total Physical Wt:\n                      " + _vm._s(_vm.tripdata.LmTotalPhysicalWt))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total MPS to be delivered:" + _vm._s(_vm.tripdata.totalMpsLm))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  })]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('th', {
    staticClass: "text-center short"
  }, [_c('strong', [_vm._v("Client Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Address")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("AWB")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_c('span', [_vm._v("Actual ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v("Physical Wt(Kg)")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("#MPS")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Value Added Services")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Booking Mode (Ca/Cr/FTC)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Signature with Name/ Stamp/ID/Remarks")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Date & Time Of Delivery ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tripdata.deliveries), function(client, index) {
    return (_vm.tripdata.deliveries.length > 0) ? [_vm._l((client.shipments), function(shipment, ind) {
      return [(ind == 0) ? [_c('tr', {
        staticStyle: {
          "background-color": "white"
        }
      }, [_c('td', {
        staticClass: "text-center",
        attrs: {
          "rowspan": client.shipments.length,
          "scope": "rowgroup"
        }
      }, [_vm._v("\n                            " + _vm._s(client.clientname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "rowspan": client.shipments.length,
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.address))]), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s(shipment.pincode))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("EWB:")]), _vm._v(" "), (shipment.gst.length > 0) ? [_vm._l((shipment.gst), function(ebn) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(ebn.ewbn))]), _c('br')]
      })] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.awb))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v(_vm._s(shipment.physcialWeight))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v("Total:" + _vm._s(shipment.bookedMps))]), _vm._v(" "), _c('hr', {
        staticStyle: {
          "width": "100%",
          "color": "black",
          "background-color": "black"
        }
      }), _vm._v(" "), _c('br'), _c('span', [_vm._v("OFD:" + _vm._s(shipment.ofdCount))]), _vm._v(" "), _c('hr', {
        staticStyle: {
          "width": "100%",
          "color": "black",
          "background-color": "black"
        }
      }), _vm._v(" "), _c('br'), _c('span', [_vm._v("Pending:" + _vm._s((shipment.bookedMps - shipment.ofdCount)))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "border-top": "none"
        },
        attrs: {
          "scope": "rowgroup"
        }
      }, [(shipment.deliverydatetime != null) ? _c('div', {
        staticClass: "apptDate"
      }, [_c('span', [_vm._v("AD")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.dateFormatforApptDate(shipment.deliverydatetime)))])]) : _vm._e(), _vm._v(" "), (shipment.malldelivery == 'Yes') ? _c('span', {
        staticClass: "mall"
      }, [_vm._v(" MD ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [(shipment.bookingmode != 'ToPay') ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v(_vm._s(shipment.bookingmode))]) : _vm._e(), _vm._v(" "), (shipment.bookingmode == 'ToPay') ? _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("FTC")]) : _vm._e(), _vm._v(" "), (shipment.bookingmode == 'ToPay') ? _c('span', [_vm._v(_vm._s(shipment.ftcamount))]) : _vm._e()]), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      }), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      })])] : (ind > 0) ? [_c('tr', {
        staticStyle: {
          "background-color": "white"
        }
      }, [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.awb))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_vm._v(_vm._s(shipment.physcialWeight))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [_c('span', [_vm._v("Total:" + _vm._s(shipment.bookedMps))]), _vm._v(" "), _c('hr', {
        staticStyle: {
          "width": "100%",
          "color": "black",
          "background-color": "black"
        }
      }), _vm._v(" "), _c('br'), _c('span', [_vm._v("OFD:" + _vm._s(shipment.ofdCount))]), _vm._v(" "), _c('hr', {
        staticStyle: {
          "width": "100%",
          "color": "black",
          "background-color": "black"
        }
      }), _vm._v(" "), _c('br'), _c('span', [_vm._v("Pending:" + _vm._s(shipment.bookedMps - shipment.ofdCount))])]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "rowgroup"
        }
      }, [(shipment.deliverydatetime != null) ? _c('div', {
        staticClass: "apptDate"
      }, [_c('span', [_vm._v("AD")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.dateFormatforApptDate(shipment.deliverydatetime)))])]) : _vm._e(), _vm._v(" "), (shipment.malldelivery == 'Yes') ? _c('span', {
        staticClass: "mall"
      }, [_vm._v(" MD ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_c('span', [_vm._v(_vm._s(shipment.bookingmode))])]), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      }), _vm._v(" "), _c('td', {
        attrs: {
          "scope": "rowgroup"
        }
      })])] : _vm._e()]
    })] : _vm._e()
  }), _vm._v(" "), (_vm.tripdata.totalAwbDeliver < 6 || !_vm.tripdata.totalAwbDeliver) ? _vm._l(((!_vm.tripdata.totalAwbDeliver ? 6 : (6 - _vm.tripdata.totalAwbDeliver))), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "style1"
    }), _vm._v(" "), _c('td', {
      staticClass: "style2"
    }), _vm._v(" "), _c('td', {
      staticClass: "style3"
    }), _vm._v(" "), _c('td', {
      staticClass: "style7",
      attrs: {
        "width": "20"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "style4"
    }), _vm._v(" "), _c('td', {
      staticClass: "style5"
    }), _vm._v(" "), _c('td', {
      staticClass: "style6"
    }), _vm._v(" "), _c('td', {
      staticClass: "style6"
    }), _vm._v(" "), _c('td', {
      staticClass: "style5"
    })])
  }) : _vm._e()], 2)])]], 2)])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-584981bc","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/TripSheetPdf/TripSheetPdf.html
// module id = 1353
// module chunks = 3